// src/components/ui/about/CtaButton.client.tsx

"use client"

import Link from "next/link"
import { Button } from "~/components/Button"
import { siteConfig } from "~/lib/config/site"
import { sendButtonClickEvent } from "~/lib/gtag"

export default function CtaButtonClient(): JSX.Element {
  return (
    <Link href={siteConfig.baseLinks.requestAccess}>
      <Button className="h-8 sm:h-10 text-sm sm:text-base font-semibold px-4 sm:px-6" onClick={() => sendButtonClickEvent("Request Access", "About CTA")}>Request Access</Button>
    </Link>
  )
}
